module.exports = __webpack_public_path__ + "img/Ctrip.49dcb838.png";